export default "__VITE_ASSET__2td5SYTQ__"